<template>
	<div class="cm-mobile cm-mobile-details cm-mobile-toolbar">
		<div class="container h-100 position-relative">
			<div class="mobile-body toolbar-body">
				<div class="row h-100 g-0 justify-content-between align-items-stretch">
					<div class="col">
						<a
							v-if="
								this.$store.state.user.bookmarks.cars[car._id] !== undefined
							"
							href="#"
							@click.prevent="this.removeCarFromBookmarks(car._id)"
							class="link-toolbar-sm"
							><i class="mdi mdi-star text-primary"></i> Gemerkt</a
						>
						<a
							v-else
							href="#"
							@click.prevent="this.addCarToBookmarks(car)"
							class="link-toolbar-sm"
							><i class="mdi mdi-star-outline"></i> Merken</a
						>
					</div>
					<div class="col">
						<a
							data-bs-toggle="modal"
							href="#modalShareCar"
							class="link-toolbar-sm border-start"
							><i class="mdi mdi-share-variant"></i> Teilen
						</a>
					</div>
					<div class="col" v-if="whatsappOnline()">
						<a
							target="_blank"
							:href="getWhatsAppLink(car, this.$store.state.price, carTitle)"
							class="link-toolbar-sm border-start btn-whatsapp-carmarket-lead"
						>
							<i class="mdi mdi-whatsapp"></i> WhatsApp
						</a>
					</div>
					<div class="col-5" style="min-width: 108px">
						<a
							href="#"
							@click.prevent="scrollTo('card-contact', -60)"
							class="link-toolbar border-start"
							>Anfragen <i class="mdi mdi-send"></i
						></a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'DetailsMobileToolbar',
	components: {},
	props: {
		car: Object,
		carTitle: String,
	},
}
</script>

<style lang="scss"></style>
